import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Switch, Router, Route, Redirect } from 'react-router-dom';
import * as Sentry from '@sentry/browser';

import Signup from '../components/signup/Signup';
import SignIn from '../components/signin/SignIn';
import history from './history';
import NotSent from '../components/commands/notSent/NotSent';
import SentByMe from '../components/commands/sentByMe/SentByMe';
import SentToMe from '../components/commands/sentToMe/SentToMe';
import ReturnVouchers from '../components/vouchers/Vouchers';
import Dashboard from '../components/dashboard/Dashboard';
import ExportCommands from '../components/exportCommands/ExportCommands';
import Exports from '../components/exports/Exports';
import ImportCommands from '../components/ImportCommands/ImportCommands';
import AddCommand from '../components/addCommand/AddCommand';
import Receptions from '../components/receptions/Receptions';
import Reception from '../components/receptions/Reception';
import Operations from '../components/operations/Operations';
import Operation from '../components/operations/Operation';
import MagicLink from '../components/magicLink/MagicLink';
import UserProfile from '../components/userProfile/UserProfile';
import GeneralConditions from '../components/GeneralConditions/GeneralConditions';
import Stock from '../components/stock/Stock';
import PrivateLayout from './PrivateLayout';
import ImportProducts from '../components/importProducts/ImportProducts';

function AppRouter({ isLoggingIn, currentUser }) {
  // Ajout de l'utilisateur de la session au sentry
  Sentry.configureScope(scope => {
    scope.setUser({ email: currentUser.email });
  });
  return (
    <div>
      <Router history={history}>
        <Switch>
          {isLoggingIn && <Redirect from="/signin" to="/not-sent" />}
          {isLoggingIn && <Redirect from="/signup" to="/not-sent" />}
          <Route path="/magic-link/:token" component={MagicLink} />
          <Route path="/signin" exact component={SignIn} />
          <Route path="/signup" exact component={Signup} />
          <Route path="/terms" component={GeneralConditions} />
          <PrivateLayout
            authed={isLoggingIn}
            path="/dashboard"
            component={Dashboard}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/receptions"
            component={Receptions}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/reception/:receptionId"
            component={Reception}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/operations"
            component={Operations}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/operation/:operationId"
            component={Operation}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/not-sent"
            component={NotSent}
          />

          <PrivateLayout
            authed={isLoggingIn}
            path="/sent-by-me"
            component={SentByMe}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/sent-to-me"
            component={SentToMe}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/return-vouchers"
            component={ReturnVouchers}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/export-commands"
            component={ExportCommands}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/exports"
            component={Exports}
          />

          <PrivateLayout authed={isLoggingIn} path="/stock" component={Stock} />
          <PrivateLayout
            authed={isLoggingIn}
            path="/profile"
            component={UserProfile}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/import-commands"
            component={ImportCommands}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/add-command"
            component={AddCommand}
          />
          <PrivateLayout
            authed={isLoggingIn}
            path="/import-products"
            component={ImportProducts}
          />
          <Redirect from="/" to="/signin" />
        </Switch>
      </Router>
    </div>
  );
}

const mapStateToProps = state => ({
  isLoggingIn: state.init.isLoggingIn,
  currentUser: state.init.currentUser
});

AppRouter.propTypes = {
  isLoggingIn: PropTypes.bool,
  currentUser: PropTypes.object
};

export default connect(mapStateToProps)(AppRouter);
